import type { SVGProps } from 'react';

export function EmailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.48688 16.3918C9.12308 16.5576 8.88398 16.7825 8.71058 17.1221L8.55688 17.423V35.589C8.55688 52.102 8.56588 53.7747 8.65598 53.972C8.81558 54.3215 9.08738 54.5993 9.42238 54.7552L9.73488 54.9008H34.9999H60.2649L60.5774 54.7552C60.9124 54.5993 61.1842 54.3215 61.3438 53.972C61.4337 53.775 61.4445 52.1025 61.46 35.868C61.4707 24.586 61.4548 17.8368 61.417 17.5905C61.3381 17.0753 61.0617 16.6834 60.6113 16.4482L60.2818 16.276L35.0083 16.2774C10.6844 16.2787 9.72558 16.2829 9.48688 16.3918ZM13.706 19.3666C14.0278 19.6538 31.3127 32.8938 31.6546 33.115C32.563 33.7027 33.5097 33.9973 34.6644 34.0518C35.967 34.1133 37.1656 33.8314 38.1613 33.2295C38.5109 33.0182 56.0354 19.6146 56.3228 19.3388C56.337 19.3252 46.7407 19.314 34.9979 19.314C23.2549 19.314 13.6736 19.3377 13.706 19.3666ZM11.5639 36.7284V51.926H34.9999H58.4359V36.7284C58.4359 24.5793 58.4203 21.543 58.3584 21.5916C57.9725 21.8941 41.2104 34.7759 40.7916 35.0918C39.1969 36.2947 37.6918 36.8891 35.8076 37.0598C33.4433 37.2741 31.2323 36.6187 29.2339 35.1112C28.8122 34.793 11.9237 21.815 11.6414 21.592C11.5795 21.5431 11.5639 24.579 11.5639 36.7284Z"
        fill={props.fill || '#FF7373'}
      />
    </svg>
  );
}
